export default __webpack_public_path__ + "static/media/prithvi.87d5cccc.png";